<template>
  <v-container grid-list-md fluid>
    <Edit
      :editDialog="editDialog"
      @close="closeEdit"
      @updated="updated"
      :editFromStore="false"
      :task="task"
    >
    </Edit>
    <v-layout class="mt-5" v-if="isLoading" align-center justify-center column fill-height>
      <v-progress-circular
        size="70"
        width="7"
        color="purple"
        indeterminate="indeterminate"
      ></v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-card>
          <v-toolbar class="elevation-0" height="45" color="gray">
            <v-toolbar-title>
              <h1 class="subheading">Task</h1>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip v-model="task.isComplete" small color="green" text-color="white"
              >Complete</v-chip
            >
            <v-btn icon @click="editTask()">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout column>
              <v-layout row="row" wrap="wrap">
                <v-flex sm12="sm12">{{ $t("labels.title") }}</v-flex>
                <v-spacer> </v-spacer>
                <v-flex class="font-weight-regular text-xs-left" sm12="sm12">
                  <p>{{ task.title }}</p>
                </v-flex>
              </v-layout>
              <v-divider> </v-divider>
              <v-layout row="row" wrap="wrap">
                <v-flex sm12="sm12">{{ $t("labels.description") }}</v-flex>
                <v-spacer> </v-spacer>
                <v-flex class="font-weight-regular text-xs-left" sm12="sm12">
                  <p>{{ task.description }}</p>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-layout column>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">Detail</h1>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout column>
                  <v-flex>
                    <v-layout>
                      <v-flex>Assigned To</v-flex>
                      <v-spacer> </v-spacer>
                      <v-flex class="font-weight-regular text-xs-right">
                        {{ task.assignedToUser.fullName }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider></v-divider>
                  <v-flex>
                    <v-layout>
                      <v-flex>Created By</v-flex>
                      <v-spacer> </v-spacer>
                      <v-flex class="font-weight-regular text-xs-right">
                        {{ task.reporterUser.fullName }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider></v-divider>
                  <v-flex>
                    <v-layout>
                      <v-flex>Created At</v-flex>
                      <v-spacer> </v-spacer>
                      <v-flex class="font-weight-regular text-xs-right">
                        {{ task.createdAt | moment("MM/DD/YYYY") }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider></v-divider>
                  <v-flex>
                    <v-layout>
                      <v-flex>{{ $t("labels.dueDate") }}</v-flex>
                      <v-spacer> </v-spacer>
                      <v-flex class="font-weight-regular text-xs-right">
                        {{ task.dueDate | moment("MM/DD/YYYY") }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider></v-divider>
                  <v-flex>
                    <v-layout>
                      <v-flex>{{ $t("labels.priority") }}</v-flex>
                      <v-spacer> </v-spacer>
                      <v-flex class="font-weight-regular text-xs-right">
                        <span v-if="task.taskPriorityDetail">{{
                          task.taskPriorityDetail.selector
                        }}</span>
                        <span v-else>Not Set</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider></v-divider>
                  <v-flex>
                    <v-layout>
                      <v-flex>Complete</v-flex>
                      <v-spacer> </v-spacer>
                      <v-flex class="font-weight-regular text-xs-right">
                        <span v-if="task.isComplete">Yes</span>
                        <span v-else>No</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md8>
        <CommentList
          :refID="task.id"
          :ownerID="this.task.assignedToUserID"
          :typeId="6"
          @commentCreated="commentCreated"
          :storeID="task.id"
        >
        </CommentList>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import taskService from "../service";
import notificationService from "../../Layout/service";
import CommentList from "../../Comment/components/List";
import { mapGetters } from "vuex";
const Edit = () => import("../components/Edit");

export default {
  components: {
    Edit,
    CommentList
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadTask();
      }
    }
  },
  data() {
    return {
      isLoading: true,
      editDialog: false,
      task: null
    };
  },
  created() {
    this.loadTask();
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  methods: {
    editTask() {
      this.editDialog = !this.editDialog;
    },
    commentCreated(val) {
      notificationService.setNotification({
        heading: "New Comment",
        body: `Comment was left on your task # ${this.task.id} by `,
        comment: val,
        forUserID: this.task.assignedToUserID,
        forUserName: this.task.assignedToUser.fullName,
        link: `task/profile/${this.task.id}`,
        fromID: this.task.id,
        typeID: 3,
        from: "comment",
        label: "task",
        emailAddress: this.task.assignedToUser.loginEmail,
        fromUserID: this.currentUser.userID,
        fromUserName: this.currentUser.fullName
      });
      // console.log('commit', val, this.task)
      if (this.task.reporterUserID !== this.currentUser.userID) {
        notificationService.setNotification({
          heading: "New Comment",
          body: `Comment was left for you on task # ${this.task.id} by `,
          comment: val,
          forUserID: this.task.reporterUserID,
          forUserName: this.task.reporterUser.fullName,
          link: `task/profile/${this.task.id}`,
          fromID: this.task.id,
          typeID: 3,
          from: "comment",
          label: "task",
          emailAddress: this.task.reporterUser.loginEmail,
          fromUserID: this.currentUser.userID,
          fromUserName: this.currentUser.fullName
        });
      }
    },
    loadTask() {
      const id = this.$route.params.id;
      this.$Progress.start();
      return taskService.getById(id).then(response => {
        console.log("response task", response);
        this.$Progress.finish();
        this.task = response.data;
        this.isLoading = false;
      });

      this.$Progress.finish();
    },
    deleteTask() {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          taskService
            .delete(this.task.id)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Task has been deleted.", "success");
                this.getList();
              }
            })
            .catch(error => {
              throw error;
            });
        }
      });
    },

    closeEdit() {
      this.editDialog = false;
    },
    updated() {
      this.closeEdit();
      this.loadTask();
    }
  }
};
</script>
